import { render, staticRenderFns } from "./CustomersToolbar.vue?vue&type=template&id=45b753d2&"
import script from "./CustomersToolbar.vue?vue&type=script&lang=js&"
export * from "./CustomersToolbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports